// extracted by mini-css-extract-plugin
export var actionButtons = "_86-2";
export var boldCardText = "_86-4";
export var cancelButtons = "_86-3";
export var infoText = "_86-1";
export var rescheduleModalContent = "_86-0";